// extracted by mini-css-extract-plugin
export var absent = "votes-module--absent--ckcB5";
export var barChartContainer = "votes-module--bar-chart-container--Y3E-O";
export var contentContainer = "votes-module--content-container--KLifN";
export var date = "votes-module--date--pev8U";
export var exp = "votes-module--exp--1pNdh";
export var highlight = "votes-module--highlight--eOp-k";
export var no = "votes-module--no--M2nXG";
export var noVote = "votes-module--no-vote--OwyUm";
export var result = "votes-module--result--tmDvC";
export var subhed = "votes-module--subhed--ci3eB";
export var tableContainer = "votes-module--table-container--7vurN";
export var text = "votes-module--text--+SR2V";
export var yes = "votes-module--yes--tu4O4";